import Crud from '../views/TipoCuidado/Crud'
import Entity from '../views/TipoCuidado/Add'

let routes = {
    path: '/tipo_cuidado',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/tipo_cuidado/add',
            name: 'NewProduto',
            component: Entity
        },
        {
            path: '/tipo_cuidado/edit/:id?',
            name: 'EditProduto',
            component: Entity
        },
        {
            path: '/tipo_cuidado',
            name: 'list-tipo-cuidado-produtos',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Tipos de Cuidados de Produtos',
                breadcrumb: [
                    {
                        text: 'Tipos de Cuidados de Produtos',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
